import { ChatConfig } from '@apparel/core/chat/ChatConfig';
import { getPlatformTag } from '@apparel/core/platform';

export const GLOBAL_CHAT_CONFIG: Partial<ChatConfig> = {
    /*
     * To support covcare and apparel as dedicated platforms the sub-platform tag will be ignored,
     * So messages from apparel get `apparel` tag, and messages from covcare get `covcare` tag.
     */
    platform: getPlatformTag(),
};
